/**
 * SeatMap
 * 詳細設計書 §4.2「SeatMap のレイアウト実装詳細」に対応。
 *
 * Props:
 *   seats         {Array}  seat-map API レスポンスの seats[]
 *   mySeatNumber  {string|null} 自分の座席番号
 */
import SeatCard from './SeatCard';
import { ROWS, COLS, UNAVAILABLE_SEATS, E_SEATS } from '../constants/floorLayout';

function SeatMap({ seats = [], mySeatNumber = null }) {
  // seat_number をキーに素早く参照できる Map を作成
  const seatMap = {};
  seats.forEach((s) => {
    seatMap[s.seat_number] = s;
  });

  return (
    <div className="life-seat-map__scroll">
      {/* メイングリッド: 5行 × 4列 */}
      <div className="life-seat-map__grid">
        {ROWS.map((row) => (
          <div key={row} className="life-seat-map__row">
            {COLS.map((col) => {
              const id = `${col}-${String(row).padStart(2, '0')}`;
              const info = seatMap[id];
              return (
                <SeatCard
                  key={id}
                  seatId={id}
                  isMine={id === mySeatNumber}
                  isOccupied={info?.is_occupied ?? false}
                  occupantName={info?.occupant_name ?? null}
                />
              );
            })}
          </div>
        ))}
      </div>

      {/* 下段エリア: 使用不可席 + E 席（絶対配置） */}
      <div className="life-seat-map__lower">
        {/* F-01〜F-04: 使用不可（静的） */}
        {UNAVAILABLE_SEATS.map(({ id, style }) => (
          <SeatCard key={id} seatId={id} isUnavailable style={style} />
        ))}

        {/* E-01〜E-03: 円卓エリア（API データ参照） */}
        {E_SEATS.map(({ id, style }) => {
          const info = seatMap[id];
          return (
            <SeatCard
              key={id}
              seatId={id}
              isMine={id === mySeatNumber}
              isOccupied={info?.is_occupied ?? false}
              occupantName={info?.occupant_name ?? null}
              style={style}
            />
          );
        })}
      </div>
    </div>
  );
}

export default SeatMap;
